import "./style.scss";
import 'react-tippy/dist/tippy.css'
import {
  Tooltip,
} from 'react-tippy';
import {ReactComponent as InfoIcon} from "../../../assets/icons/info.svg";

const Tippy = ({content, size="big", iconSize="1.6rem", marginLeft="0.5rem", marginRight="0"}) => {
  return <Tooltip
    // options
    title={content}
    position="top"
    trigger="mouseenter"
    duration={100}
    size={size}
  >
    <InfoIcon style={{marginTop:"0.2rem",marginLeft:marginLeft, marginRight:marginRight, width:iconSize, height:iconSize}} stroke={"var(--secondary)"}/>
  </Tooltip>
}

export default Tippy;